import React from "react";
import { provider } from "react-ioc";
import ThemeProvider from "./theme/ThemeProvider";

interface AppProviderProps {
  children?: React.ReactNode;
}

const AppProvider: React.FC<AppProviderProps> = ({ children }) => (
  <ThemeProvider>{children}</ThemeProvider>
);
export default provider()(AppProvider);
